/**
 * Meal Plan Estimation Utilities
 *
 * Utility functions for calculating meal plan generation time estimates.
 *
 * @module utils/mealPlanEstimation
 */

/**
 * Calculate estimated meal plan generation time in seconds
 *
 * Formula: 30 + Math.ceil((mealCount * mealTypesCount / 7)) * 40
 *
 * @param mealCount - Number of days for the meal plan
 * @param mealTypesCount - Number of meal types selected
 * @returns Estimated time in seconds
 */
export const calculateEstimatedTimeSeconds = (
  mealCount: number,
  mealTypesCount: number
): number => {
  if (!mealCount || mealCount <= 0 || !mealTypesCount || mealTypesCount <= 0) {
    return 30; // Default minimum time
  }

  return 30 + Math.ceil((mealCount * mealTypesCount / 7)) * 40;
};

/**
 * Format seconds into a human-readable time string
 *
 * @param seconds - Time in seconds
 * @returns Formatted string (e.g., "1 minute 30 seconds", "45 seconds", "2 minutes")
 */
export const formatEstimatedTime = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  if (minutes === 0) {
    return `${remainingSeconds} second${remainingSeconds !== 1 ? 's' : ''}`;
  } else if (remainingSeconds === 0) {
    return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
  } else {
    return `${minutes} minute${minutes !== 1 ? 's' : ''} ${remainingSeconds} second${remainingSeconds !== 1 ? 's' : ''}`;
  }
};